import React,{ Component } from 'react';
// import PropTypes from 'prop-types';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch'

import AgencyPortal from '../../AgencyPortal';
import ProviderPortal from '../../ProviderPortal';
import OnboardingPortal from '../../OnboardingPortal';
import Login from '../../Login';
import SetPassword from '../../SetPassword';
import ForgotPassword from '../../ForgotPassword';
import GuidedCampaignCreation from '../../GuidedCampaignCreation';

import ReactGA from 'react-ga';
import PreviewCampaign from "../../PreviewCampaign";
import PhonePreviewCampaign from "../../PhonePreviewCampaign";

const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

class Portal extends Component {  
  componentWillMount(){
    Promise.all([
      this.props.loadAuthTokenFromCookie(),
      this.props.loadImpersonateTokenFromCookie(),
    ]);

    this.trackPageView(this.props.location);
    this.unbindHistoryListener = this.props.history.listen((location) => {
      this.trackPageView(location);
    });
  }

  componentDidMount(){
    this.props.loadVersion();
  }

  componentWillUnmount(){
    this.unbindHistoryListener();
  }

  trackPageView(location){
    const sanitizedPathname = location.pathname.split('/').map((part) => GUID_REGEX.test(part) ? '<ID>' :part).join('/');
    ReactGA.pageview(sanitizedPathname);
  }

  render(){
    return (
      <div className='Portal'>
        <Switch>
          <Route exact path='/login'        component={Login} />
          <Route exact path='/set-password' component={SetPassword} />
          <Route exact path='/reset'        component={ForgotPassword} />
          <Route path='/account'            component={AgencyPortal} />
          <Route path='/impersonate/:email' component={AgencyPortal} />
          <Route path='/superadmin'         component={ProviderPortal} />
          <Route path='/welcome'            component={OnboardingPortal} />
          <Route path='/invite'             component={OnboardingPortal} />
          <Route path='/tutorial'           component={GuidedCampaignCreation} />
          <Route path='/preview/:previewToken' component={PreviewCampaign} />
          <Route path='/phonepreview' component={PhonePreviewCampaign} />
          <Route                            component={Login} />
        </Switch>
      </div>
    )
  }
}

export default Portal;



// WEBPACK FOOTER //
// ./src/routes/Portal/components/Portal.js